<template>
    <div class="container-fluid">

        <div class="row mb-3">
            <div class="col">
                <b-card no-body  bg-variant="light" class="mb-3">
                    <template v-slot:header>
                        <font-awesome-icon icon="address-card" style="margin-right: 12px" />
                        <span class="text-capitalize">{{athleteName}}</span>
                    </template>
                    <b-list-group flush class="data-item">
                        <b-list-group-item>
                            <span class="text-capitalize">{{athleteDetails}}</span>
                            <!-- disabled TODO
                           <b-button size="sm" class="mx-2" style="border-width: 0px" variant="outline-secondary" v-on:click.stop="onEditAthlete()">
                               <font-awesome-icon icon="edit" />
                           </b-button>
                           -->
                        </b-list-group-item>
                    </b-list-group>
                </b-card>

                <b-card no-body bg-variant="light" style="min-height: 180px;">
                    <template v-slot:header>
                        <font-awesome-icon icon="comment-alt" style="margin-right: 12px" />
                        <span>Notes</span>
                        <b-button size="sm" class="mx-2" style="border-width: 0px" variant="outline-secondary" v-on:click.stop="onEditSessionNotes()">
                            <font-awesome-icon icon="edit" />
                        </b-button>
                    </template>
                    <b-card-text>
                        <b-form-textarea
                                id="notes-input"
                                class="p-2"
                                placeholder="None"
                                :value="sessionValue.notes"
                                rows="4"
                                max-rows="6"
                                plaintext
                        />
                    </b-card-text>
                </b-card>

            </div>
            <div class="col">
                <b-card no-body bg-variant="light" class="mb-3">
                    <template v-slot:header>
                        <font-awesome-icon icon="clock" style="margin-right: 12px" />
                        <span>Time</span>
                    </template>
                    <b-list-group flush class="data-item">
                        <b-list-group-item>
                            <div class="d-flex justify-content-between">
                                <div><b>Start Time:</b></div>
                                <div>{{sessionValue.startTime | moment("MMMM Do, YYYY, h:mm:ss a")}}</div>
                            </div>
                        </b-list-group-item>
                        <!--
                        <b-list-group-item>
                            <div class="d-flex justify-content-between">
                                <div><b>End Time:</b></div>
                                <div>{{sessionValue.endTime | moment("MMMM Do, YYYY, h:mm:ss a")}}</div>
                            </div>
                        </b-list-group-item>
                        -->
                        <b-list-group-item>
                            <div class="d-flex justify-content-between">
                                <div><b>Elapsed Time:</b></div>
                                <div>{{ elapsedSeconds | numeralFormat('00:00:00') }}</div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
                <b-card no-body bg-variant="light" class="mb-3">
                    <template v-slot:header>
                        <font-awesome-icon icon="mobile-alt" style="margin-right: 12px" />
                        <span>VO2 Master Properties</span>
                    </template>
                    <b-list-group flush class="data-item">
                        <b-list-group-item>
                            <div class="d-flex justify-content-between">
                                <div><b>Venturi Size:</b></div>
                                <div style="text-transform:capitalize">{{ sessionValue.venturiSize }}</div>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item>
                            <div class="d-flex justify-content-between">
                                <div><b>Mask Size:</b></div>
                                <div style="text-transform:capitalize">{{ sessionValue.maskSize }}</div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </div>
        </div>

      <!-- Protocol -->
        <div class="row mb-3">
            <div class="col">
                <b-card no-body bg-variant="light" class="mb-3" style="min-height: 180px;">
                    <template v-slot:header>
                        <font-awesome-icon icon="clipboard-list" style="margin-right: 12px" />
                        <span>Protocol</span>
                    </template>
                    <b-list-group flush class="data-item" >
                        <b-list-group-item >
                            <h5>{{ sessionValue.protocolPlan.typeName }}</h5>
                        </b-list-group-item>
                        <b-list-group-item v-for="item in sessionValue.protocolPlan.metaFields" :key="item.type">
                            <div>{{ item.name }}:   {{ item.value }}</div>
                        </b-list-group-item>
                        <b-list-group-item v-for="item in sessionValue.protocolPlan.phases" :key="item.type">
                            <h5>{{ item.name }}</h5>
                            <ul v-for="setting in item.settings" :key="setting.type" class="list-unstyled text-muted my-1" style="font-size: small">
                                <li>{{ setting.name }}:  {{ setting.value }}</li>
                            </ul>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </div>
            <div class="col">
                <b-card no-body bg-variant="light" class="mb-3">
                    <template v-slot:header>
                        <font-awesome-icon icon="mobile-alt" style="margin-right: 12px" />
                        <span>Recording Device</span>
                    </template>
                    <b-list-group flush class="data-item">
                        <b-list-group-item>App Version: {{ sessionValue.systemAppVersion }}</b-list-group-item>
                        <b-list-group-item>{{ sessionValue.systemPlatform }} {{ sessionValue.systemPlatformVersion }}</b-list-group-item>
                    </b-list-group>
                </b-card>
                <b-card no-body bg-variant="light">
                    <template v-slot:header>
                        <font-awesome-icon icon="broadcast-tower" style="margin-right: 12px" />
                        <span>Sensors</span>
                    </template>
                    <b-list-group flush class="data-item">
                        <b-list-group-item v-for="item in sessionValue.devices" :key="item.identifier">
                            <h6>{{ item.displayName }}</h6>
                            <span style="font-size: small">{{ item.userDescription }}</span>
                            <ul class="list-unstyled text-muted" style="font-size: small">
                               <!-- <li>Identifier: {{ item.identifier }}</li> -->
                                <li>Serial: {{ item.serialNumber }}</li>
                                <li>Model: {{ item.modelNumber }}</li>
                                <li>System: {{ item.systemID }}</li>
                                <li>Manufacturer:{{ item.manufacturerName }}</li>
                            </ul>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "SessionDetailsTab",
        props: ['athlete', 'session', 'elapsedSeconds'],
        computed: {

            sessionValue: function() {

              let value = {
                    startTime: '',
                    endTime: '',
                    notes: '',
                    devices: [],
                    systemPlatform: '-',
                    systemPlatformVersion: '-',
                    systemAppVersion: '-',

                    venturiSize: '-',
                    volumeCorrectionMode: '-',
                    maskSize: '-',

                    protocolPlan: {
                        typeName: 'Free',
                        type: '-',
                        intensityType: '-',
                        phases: [],
                        metaFields: []
                    },

              };

                if(this.session) {

                    value.startTime = this.session.startTime;
                    value.endTime = this.session.endTime;
                    value.notes = this.session.notes;
                    value.devices = this.session.devices ?? [];
                    value.systemPlatform = this.session.systemPlatform ?? '-';
                    value.systemPlatformVersion = this.session.systemPlatformVersion ?? '-';
                    value.systemAppVersion = this.session.systemAppVersion ?? '-';

                    value.venturiSize = this.session.venturiSize ?? '-';
                    value.maskSize = this.session.maskSize ?? '-';
                    value.volumeCorrectionMode = this.session.volumeCorrectionMode ?? '-';


                    if(this.session.protocolPlan) {
                        value.protocolPlan = this.session.protocolPlan;
                    }
                }

              return value;
            },
            athleteName: function () {
                let name = '-';

                if (this.athlete) {
                    name = this.athlete.name ?? '';
                    name = (name !== undefined && name != '') ? name : '(empty athlete name)';
                }
                return name ?? '-';
            },

            athleteDetails: function() {
                let details = '';
                if(this.athlete) {
                    details += this.athlete.sex;
                    if(this.session) {
                        details += ', ';
                        details += this.session.athleteWeight + ( this.session.athleteWeightUnit == 'kilogram' ? 'kg, ' : 'lb, ');
                        details += this.session.athleteHeight + ( this.session.athleteHeightUnit == 'centimeter' ? 'cm, ' : 'inches, ');
                    }
                }

                return details;
            },

        },
        methods:
        {
            onEditSessionNotes: function() {
                this.$bvModal.show('edit-session-notes-modal')
            },
            onEditAthlete: function() {
                alert("TODO");
            }
        }
    }
</script>

<style scoped>

    .data-item {
        font-size: small;
    }

</style>